import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  display: flex;
  margin: 10px;
  width: 90vw;
  height: 419px;
  .CommunityCard_wrapper {
    width: 100%;
    display: flex;
  }
  .CommunityCard_inner {
    width: 100%;
    display: flex;
    background-color: #FFFFFF;
    flex-direction: column;
  }
  .CommunityCard_media {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 198px;
      object-fit: cover;
    }
    .CommunityStatus {
      position: absolute;
      bottom: 0;
      font-size: 16px;
      width: 100%;
      height: auto;
      color: ${colors.white};
      font-weight: 800;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 5px 10px;
      text-align: center;
      text-shadow: 1px 1px rgba(0, 0, 0, 0.54);
    }

    .Final_opportunity {
      background-color: rgba(218, 82, 31, 0.88) !important;
    }
    .Status_coming {
      background-color: rgba(244, 192, 10, 0.88) !important;
    }
    .Status_grand {
      background-color: rgba(64, 121, 0, 0.88) !important;
    }
    .Status_sold {
      background-color: rgba(168, 4, 4, 0.88) !important;
    }

    .CommunityStatusComing {
      position: absolute;
      bottom: 0;
      font-size: 16px;
      background-color: rgba(60,157,199,0.65);
      width: 100%;
      height: auto;
      color: ${colors.white};
      font-weight: 800;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 10px;
      text-align: center;
      text-shadow: 1px 1px rgba(0, 0, 0, 0.54);
    }
  }
  .CommunityCard_content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .CommunityTitleWrapper {
      display: flex;
      height: 70px;
      padding: 0 5px 0 30px;

      .CommunityTitle {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h4 {
          text-align: left;
        }
      }

      a {
        width: 40px;
        display: flex;
        align-items: center;
        .CommunityCardMobile_mapButton {
          width: 40px;
          height: 40px;
          background-image: url('/images/icon-map-pin-mobile.svg');
          background-position: center center;
          background-repeat: no-repeat;
          cursor: pointer;
        }
      }
    }

    .StartingAtWrapper {
      padding-left: 30px;
      p {
        font-weight: bold;
        font-size: 13px;
        text-transform: uppercase;
        margin: 0;
      }
      span {
      font-weight: 300;
      font-size: 24px;
      }
    }


    h4 {
      font-weight: bold;
      font-size: 20px;
      color: ${colors.brand1};
      margin-bottom: 0;
      text-align: left;
    }
    h5 {
      font-size: 16px;
      margin-top: 5px;
      margin-bottom: 0;
    }

    .CommunityCard_buttonWrapper {
      display: flex;
      justify-content: center;
      margin: 5px 0;
      .CommunityCard_mapButton {
        width: 35px;
        height: 35px;
        background-color: #E9EAEA;
        background-image: url('/images/icon-map-blue.svg');
        background-position: center center;
        background-repeat: no-repeat;
        cursor: pointer;
        background-size: 20px auto;
      }
    }
  }
  .CommunityCard_detailButton {
    text-align: left;
    background-color: ${colors.brand2};
    color: ${colors.body};
    font-weight: 700;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: all .3s ease-out;
    position: relative;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;
    margin: 10px 0 0 0;
  }
  @media(min-width: 350px) {
  }
  @media (min-width:992px) {
    margin: 0 0 15px 0;
    width: auto;
    height: auto;
    .CommunityCard_wrapper {
      width: 502px;
      height: 180px;
      height: auto;
    }
    .CommunityCard_inner {
      width: 100%;
      display: flex;
      background-color: #FFFFFF;
      flex-direction: row;
    }
    .CommunityCard_media {
      width: 200px;
      margin: 0 0 0 0;
      img {
        width: 200px;
        height: 150px;
        object-fit: cover;
      }
    }
    .CommunityCard_content {
      padding: 10px 20px;
      width:100%;
      justify-content: space-evenly;
    }
    .CommunityCardMobile_mapButton {
      display: none;
    }
    .CommunityTitleWrapper {
      padding: 0 !important;
      height: auto !important;
      a {
        display: none;
      }
    }
    .StartingAtWrapper {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      padding-left: 0 !important;

      p, span {
        font-weight: 500 !important;
        font-size: 12px !important;
        letter-spacing: 0.64px;
      }
    }
  }


  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    width: 240px;
    border-radius: 0;
    .leaflet-popup-content {
      color: ##8e8e8e;
      line-height: 1.4;
      padding: 25px 15px;
      margin: 0;
      width: 100% !important;

      img {
        width: 100%;
        height: 147px;
        object-fit: cover;
      }

      h3 {
        color: ${colors.brand1};
        letter-spacing: 0.37px;
        margin-bottom: 0;
        font-weight: 600;
        font-size: 20px;
        font-family: acumin-pro-condensed,sans-serif;
        color: ${colors.brand1};
        margin: 5px 0 10px;
      }

      span {
        font-size: 14px;
      }

      .ButtonDefault {
        width: 198px;
        height: 40px;
        padding-left: 0;
        justify-content: center;
        font-size: 12px;
        color: ${colors.white};
        letter-spacing: 2.16px;
        min-width: 198px;
        &::after {
          content: "";
        }
      }
    }
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
  .Map {
    display: flex;
    flex-direction: column;

    img {
      display: none;
      @media(min-width: 768px) {
        display: block;
      }
    }
    h3 {
      text-align: left;
    }
  }
  .CommunityCard_detailButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    text-align: center;
    background-color: ${colors.brand2};
    color: ${colors.white};
    font-weight: 800;
    font-size: 13px;
    text-transform: uppercase;
    margin-top: 10px;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand2};
      transition: all .3s ease-out;
    }
    &::after {
      content: url(/images/btn-right-arrow.svg);
      margin-left: 10px;
    }
  }
`;

function CommunityCard({ community }) {
  return (
    <div className={styles}>
      <ActivateMapPin itemId={get(community, '_id')} hover>
        <div className="CommunityCard_wrapper">
          <div className="CommunityCard_inner">
            <div className="CommunityCard_media">
              <Link name="community-detail" community={community}>
                {
                  (get(community, 'logo.contentUrl') || get(community, 'photos[0].contentUrl')) &&
                  <Image
                    src={(get(community, 'logo.contentUrl') || get(community, 'photos[0].contentUrl'))}
                    alt={get(community, 'name')}
                    width={475}
                    height={315}
                    exact
                  />
                }
                {
                  !get(community, 'logo.contentUrl') && !get(community, 'photos[0].contentUrl') &&
                  <img src="/images/coming-soon.jpg" alt="Comming Soon" />
                }
                {
                  community.status === 'Coming Soon' &&
                  <div className="CommunityStatus Status_coming">Coming Soon!</div>
                }
                {
                  community.status === 'Closeout' &&
                  <div className="CommunityStatus Final_opportunity">Final Opportunities!</div>
                }
                {
                  community.status === 'Grand Opening' &&
                  <div className="CommunityStatus Status_grand">Now Open!</div>
                }
                {
                  community.status === 'Sold Out' &&
                  <div className="CommunityStatus Status_sold">Sold Out!</div>
                }
              </Link>
            </div>
            <div className="CommunityCard_content">
              <div className="CommunityTitleWrapper">
                <div className="CommunityTitle">
                  <h4>{get(community, 'name')}</h4>
                  <h5>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</h5>
                </div>
                <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
                  <div className="CommunityCardMobile_mapButton" />
                </a>
              </div>
              <div className="StartingAtWrapper">
                {
                  get(community, 'priceLow') && get(community, 'priceHigh') &&
                  <span>Price Range: {numeral(get(community, 'priceLow', '')).format('$0,0')}{get(community, 'sqftHigh') > 0 ? ` - ${numeral(get(community, 'sqftHigh')).format('0,0')}` : '+'}</span>
                }
                {
                  get(community, 'sqftLow') && get(community, 'sqftHigh') &&
                  <span>SQFT Range: {numeral(get(community, 'sqftLow', '')).format('0,0')} - {numeral(get(community, 'sqftHigh', '')).format('0,0')}</span>
                }
                {
                  get(community, 'schools[0].district') &&
                  <span>{get(community, 'schools[0].district').replace('Independent School District', 'ISD')}</span>
                }
              </div>
              <Link name="community-detail" community={community} className="CommunityCard_detailButton">Visit Community</Link>
            </div>
          </div>
        </div>
      </ActivateMapPin>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCard.js